const riot = require('riot');

riot.tag2('atom-input-image', '<div class="relative f fh s-full {&quot;cursor-pointer&quot;: !opts.disabled, &quot;pointer-none&quot;: opts.disabled === true}" onclick="{onSelectImage}"> <div class="transition relative {\'opacity-60\' : isDragover}" ondragenter="{onDragenter}"> <yield></yield> <div class="s-full absolute trbl0" if="{isDragover}" ondragleave="{onDragleave}"></div> </div> </div>', '', '', function(opts) {

    this.on('update', () => {

      if (this._prevSrc !== this.opts.riotSrc) {
      this.riotSrc = this.opts.riotSrc;
      }

      this._prevSrc = this.opts.riotSrc;
    });

    this.on('mount', () => {
      this.file = this.opts.file;
      this.input = document.createElement('input');
      this.input.type = 'file';
      this.input.accept = 'image/*';

      this.input.onchange = async (e) => {
        var file = e.currentTarget.files[0];
        if (!file) return ;

        if (!this.validateFileSize(file.size)) {
          spat.modal.alert('利用できる画像は最大5MBまでです。別の画像をご利用ください。');
          return;
        }

        this._setFile(file);
        this.input.value = '';
        this.update();
      };

      this.root.ondragover = (e) => {
        return false;
      };
      this.root.ondrop = (e) => {

        this.isDragover = false;
        this.update();
        var file = e.dataTransfer.files[0];
        if (!file) return ;

        if (!this.validateFileImageOnly(file.type)) {
          e.preventDefault();

          spat.modal.alert('その形式のファイルは投稿できません。');
          return;
        }

        if (!this.validateFileSize(file.size)) {
          spat.modal.alert('利用できる画像は最大5MBまでです。別の画像をご利用ください。');
          return;
        }

        this._setFile(file);

        return false;
      };
      this.update();
    });

    this.onDragenter = (e) => {
      this.isDragover = true;
      this.update();
    };

    this.onDragleave = (e) => {
      this.isDragover = false;
      this.update();
    };

    this.onSelectImage = (e) => {
      e.preventDefault();
      e.stopPropagation();
      if (this.opts.disabled) return ;
      this.input.click();
    };

    this.reset = () => {
      this.input.value = '';
      this.file = null;
      this.url = null;
      this.riotSrc = null;
      this.trigger('imagedelete');
      this.bubbleTrigger('datachange');
      this.update();
    };

    this._setFile = async (file) => {
      this.file = file;
      this.url = URL.createObjectURL(file);
      this.trigger('imageset', { self: this });
      this.bubbleTrigger('datachange');
      this.bubbleTrigger('fileset', {
        url: this.url,
        file: this.file,
      });
      this.update();
    };

    this.getImageURL = () => {
      return this.url || this.riotSrc;
    };

    this.getFile = () => {
      return this.file;
    };

    this.getIsUpdated = () => {

      if (!this.getFile() && !this.getImageURL()) return true;

      else if (this.getFile()) return true;

      else return false;
    };

    this.uploadAndGetImageURL = async () => {

      if (!this.getFile() && !this.getImageURL()) {
        return null;
      }

      else if (!this.getFile() && this.getImageURL()) {
        return this.getImageURL();
      }

      else {
        var url = await app.utils.uploadImageFile(this.file);
        return url;
      }
    };

    this.validateFileImageOnly = (type) => {
      var re = /(^image\/\w*)/;
      return re.test(type);
    };

    this.validateFileSize = (size) => {
      const MAX_SIZE = 5 * 1024 * 1024;
      return size <= MAX_SIZE;
    };
});